import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TestRecording } from '../models/test-recorder.model';
import { MasterService } from '../../../base-classes/master-service';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TestRecorderService extends MasterService<TestRecording> {

    constructor(http: HttpClient) {
        super(http, '/api/recordings');
        this.http = http;
    }

    saveRecording(payload: any) {
        return this.http.post<any>(`${environment.apiUrl}/recordings`, payload);
    }

    getRecordings() {
        return this.http.get<any[]>(`${environment.apiUrl}/recordings`);
    }

    getRecordingById(id: string) {
        return this.http.get<any>(`${environment.apiUrl}/recordings/${id}`);
    }

    getRecordingsPaginated(params: {
        page: number;
        pageSize: number;
        search?: string;
        client?: string;
        package?: string;
        functionalArea?: string;
        testType?: string;
        sortBy?: string;
        sortOrder?: string;
    }) {
        const queryParams: any = {
            page: params.page.toString(),
            pageSize: params.pageSize.toString(),
        };
        if (params.search) queryParams.search = params.search;
        if (params.client) queryParams.client = params.client;
        if (params.package) queryParams.package = params.package;
        if (params.functionalArea) queryParams.functionalArea = params.functionalArea;
        if (params.testType) queryParams.testType = params.testType;
        if (params.sortBy) queryParams.sortBy = params.sortBy;
        if (params.sortOrder) queryParams.sortOrder = params.sortOrder;

        return this.http.get<{ data: any[]; total: number; page: number; pageSize: number }>(
            `${environment.apiUrl}/recordings`, { params: queryParams }
        );
    }

    getReferenceList(codeKeys: string[]) {
        return this.http.post<any[]>(`${environment.apiUrl}/reference-values/by-code-keys`, { codeKeys });
    }

    getPackages() {
        return this.http.get<any[]>(`${environment.apiUrl}/packages/user-packages`);
    }

    getFunctionalAreas() {
        return this.http.get<any[]>(`${environment.apiUrl}/functional-areas`);
    }

     getUserFunctionalAreas(clientId: string): Observable<any[]> {
        return this.http.get<any[]>(`${environment.apiUrl}/functional-areas?clientId=${clientId}`);
    }

     getAllClients(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.apiUrl}/clients/user-clients`);
    }

    getUserPackages(): Observable<any[]> {
        return this.http.get<any[]>(`${environment.apiUrl}/packages/user-packages`);
    }

    getClientPackages(clientId: string): Observable<any[]> {
        return this.http.get<any[]>(`${environment.apiUrl}/client-package-mapping/client/${clientId}`);
    }

    getRecordingFilterOptions(clientId: string, packageId?: string, testTypeId?: string): Observable<{ functionalAreas: any[]; testTypes: any[] }> {
        let url = `${environment.apiUrl}/recordings/filter-options?client=${clientId}`;
        if (packageId) {
            url += `&package=${packageId}`;
        }
        if (testTypeId) {
            url += `&testType=${testTypeId}`;
        }
        return this.http.get<{ functionalAreas: any[]; testTypes: any[] }>(url);
    }

}